module.exports = __webpack_public_path__ + "static/media/kusama-2.0262fc80.png";